// Student-facing copy for the exchange configuration only. Stored answers remain unchanged.
const errors = {
  "L'adresse e-mail n'est pas valide.": 'Enter a valid email address.',
  'La date doit être au format AAAA-MM-JJ.': 'Enter the date in YYYY-MM-DD format.',
  "La date saisie n'est pas valide.": 'Enter a valid date.',
  'Vous devez avoir au moins 15 ans.': 'You must be at least 15 years old.',
  'La date de naissance ne correspond pas au numéro de sécurité sociale.': 'The date of birth does not match the social security number.',
  'Format IBAN invalide (lettres et chiffres uniquement).': 'Invalid IBAN format. Use letters and digits only.',
  'IBAN invalide (contrôle MOD 97 échoué).': 'Invalid IBAN. Please check the account number.',
  'Le BIC doit contenir 8 ou 11 caractères alphanumériques.': 'The BIC must contain 8 or 11 letters and digits.',
  'Le BIC doit commencer par 4 lettres (code banque).': 'The BIC must start with four letters (bank code).',
  'Le BIC doit contenir un code pays valide (2 lettres).': 'The BIC must contain a valid two-letter country code.',
  'Le numéro CVEC doit contenir 12 caractères (3 lettres, 1 chiffre, 6 lettres, 2 chiffres).': 'The CVEC number must contain 12 characters: 3 letters, 1 digit, 6 letters and 2 digits.',
  'Format CVEC invalide (AAA0AAAAAA00).': 'Invalid CVEC format (AAA0AAAAAA00).',
  'Le numéro de sécurité sociale doit contenir 15 caractères.': 'The social security number must contain 15 characters.',
  "L'INE doit comporter 11 ou 12 caractères alphanumériques.": 'The INE must contain 11 or 12 letters and digits.'
};

function exchangeError(message) {
  if (!message) return '';
  return errors[message] || 'Please check this field and follow the instructions above.';
}

function exchangePlaceLabel(value) {
  return String(value || '').replace(/VILLE À L'ÉTRANGER/g, 'CITY OUTSIDE FRANCE')
    .replace(/Établissement hors contrat/g, 'Independent private school')
    .replace(/Établissement par défaut/g, 'School not listed');
}

function exchangeDateError(value) {
  if (!value) return '';
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return 'Enter the date in YYYY-MM-DD format.';
  const date = new Date(value + 'T00:00:00Z');
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value) return 'Enter a valid date.';
  if (date > new Date()) return 'The date of birth cannot be in the future.';
  return '';
}

module.exports = { exchangeError, exchangePlaceLabel, exchangeDateError };
